// extracted by mini-css-extract-plugin
export default {"mainDiv":"EmailVerification_mainDiv__uVHoc","container":"EmailVerification_container__mKE1F","button":"EmailVerification_button__pok+p"};